// Figma: https://www.figma.com/file/3VI7MsyaTxG1UlmL7I4XQm/Futurize_mypage?node-id=357%3A16813
export const fonts = {
  heading: "Noto Sans JP",
  body: "Noto Sans JP",
} as const;
